import { ResponsiveOutlineIcon } from '@carboncopyco/icons';
import type { IInnerTab } from '@carboncopyco/types/desktop';
import { ToggleButton, TooltipBubble } from '@carboncopyco/ui';
import { useResponsiveModeContext } from '../../store/context/ResponsiveModeContext';

const ResponsiveModeButton = ({
  activeInnerTabId,
}: {
  activeInnerTabId: IInnerTab['id'];
}) => {
  const { isResponsiveModeActive, setIsResponsiveModeActive } =
    useResponsiveModeContext();

  return (
    <div
      className="pl-5"
      id="responsiveModeButton"
    >
      <TooltipBubble
        title="Mobile view"
        placement="left"
      >
        <ToggleButton
          dark
          selected={isResponsiveModeActive}
          icon={<ResponsiveOutlineIcon size={20} />}
          onSelect={() =>
            setIsResponsiveModeActive(!isResponsiveModeActive, activeInnerTabId)
          }
          noDrag={window?.dsDesktop?.app?.isWindows}
        />
      </TooltipBubble>
    </div>
  );
};

export default ResponsiveModeButton;
